<div
  matRipple
  class="highlight-hover sidebar-group-item"
  [routerLink]="['/db', dbId, 'inbox', inbox.id]"
  routerLinkActive="active"
  matTooltip="{{ inbox.name }}"
  matTooltipShowDelay="1000"
  matTooltipPosition="right"
  [matTooltipTouchGestures]="(isHandset$ | async) ? 'off' : 'auto'"
  ngFileDrop
  [options]="(uploaderOptions$ | async)!"
  (uploadOutput)="onUploadOutput($event)"
  [uploadInput]="uploader.input"
  [class.drag-over]="dragOver"
  (contextmenu)="onOpenMenu($event)"
>
  <span class="ellipsis">{{ inbox.name }}</span>
  <span class="spacer"></span>
  <button
    mat-icon-button
    aria-label="More archive options"
    (click)="onOpenMenu($event)"
  >
    <mat-icon>more_vert</mat-icon>
  </button>
</div>
@if (uploader.inProgress) {
  <mat-progress-bar
    mode="determinate"
    [value]="uploader.progress"
  ></mat-progress-bar>
}

<input
  #inboxFileUploader
  type="file"
  ngFileSelect
  [options]="(uploaderOptions$ | async)!"
  (uploadOutput)="onUploadOutput($event)"
  [uploadInput]="uploader.input"
  (click)="inboxFileUploader.value = ''"
  multiple
  class="hidden"
/>

<app-navigation-inbox-menu
  (importFile)="inboxFileUploader.click()"
></app-navigation-inbox-menu>
